import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'

const AppVentaRegistro = Loadable(lazy(() => import('./view/VentaRegistro')))
const AppVentaGestion = Loadable(lazy(() => import('./view/VentaGestion')))
const AppVentaRegistroOffline = Loadable(lazy(() => import('./view/VentaRegistroOffline')))

export const ventascargaRoutesMap = {
  registro: {
    name: 'Registrar T. de Carga',
    path: '/ventas/registroCarga',
  },
  registroOffline: {
    name: 'Registrar T. de Carga Offline',
    path: '/ventas/registroCarga-offline',
  },
  gestion: {
    name: 'Gestión de T. de Carga',
    path: '/ventas/gestionCarga',
  },
}
const ventasCargaRoutes = [
  {
    path: ventascargaRoutesMap.registro.path,
    element: <AppVentaRegistro />,
    auth: authRoles.admin,
  },
  {
    path: ventascargaRoutesMap.gestion.path,
    element: <AppVentaGestion />,
    auth: authRoles.admin,
  },
  {
    path: ventascargaRoutesMap.registroOffline.path,
    element: <AppVentaRegistroOffline />,
    auth: authRoles.admin,
  },
]

export default ventasCargaRoutes
